module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/pathways-virtual-counsellor-a19a063f864367331d7096582ca9c615.svg";